export const apiUrl = process.env.REACT_APP_API_URL as string;

export const phoneRegExp = /^(0[1-9])(\d{8})$/;

export const emailRegExp = /^(?!.*@[^,]*,)/;

export const passwordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!#$%&()*+,-./:;<=>?@[\\\]^_`{|}~])[A-Za-z\d!#$%&()*+,-./:;<=>?@[\\\]^_`{|}~]{14,}$/;

export const upperCaseRegex = /[A-Z]/g;
export const numbersRegex = /[0-9]/g;

export const specialCharsRegex = /(?=.*[!#$%&()*+,-./:;<=>?@[\\\]^_`{|}~])/g;

export const membershipNumberRegex = /^[A-Za-z]\d{4}$/;

//
export const blackListCharsRegex =
    /^[A-Za-z\d!#$%&()*+,-./:;<=>?@[\\\]^_`{|}~]*$/g;

export const stepsNumber = 8;

export const AcceptedFileFormatList =
    ".doc, .docx, .xls, .xlsx, .pdf, .jpg, .png";

export const sessionStorageKey = "session";
export const establishementKey = "establishment";
export const contactsStorageKey = "contacts";
export const dossierStorageKey = "dossier";
export const settingStorageKey = "setting";

export const dateFormat = "DD/MM/YYYY";

export const daysBeforeDeadlineKey = "days_before_deadline";
export const processingStepThresholdKey = "processing_step_threshold";
export const remainingDaysBeforeDeadlineKey = "remaining_days_before_deadline";

export const downloadCertificateLabelBtn = "Télécharger le certificat";

export const megaByteToByte = 1048576;
export const megaOctetThreshold = 25; // 25 mega octet

export const version = process.env.REACT_APP_VERSION;

export * from "./Home";
